window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
  },
});

const displayDeliveryDate = true;

if (
  window.location.href.includes("/tools/bundle-subscriptions") &&
  window.location.href.includes("subscriptionId=") &&
  displayDeliveryDate
) {
  const observer = new MutationObserver((mutations) => {
    if (window.Awtomic && window.Awtomic.subscriptionDetails) {
      observer.disconnect();
      const options = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      };
      const formatter = new Intl.DateTimeFormat("en-NZ", options);
      const formattedBillingDate = formatter.format(
        new Date(window.Awtomic.subscriptionDetails.NextBillingDate)
      );
      console.log("Formatted Billing Date:", formattedBillingDate);
      const subDetails = window.Awtomic.subscriptionDetails;
      let deliveryDate = subDetails.CustomAttributes[2]?.value;
      let deliveryDateObj = new Date(deliveryDate);

      if (isNaN(deliveryDateObj)) {
        const deliveryDateObjAttr = subDetails.CustomAttributes.find(
          (attr) => attr.key === "Delivery-Date"
        );
        if (deliveryDateObjAttr) {
          deliveryDateObj = new Date(deliveryDateObjAttr.value);
        }
      }

      const lastBillingDate = (() => {
        const billingAttempts =
          window.Awtomic.subscriptionBillingAttempts || [];
        const successfulAttempt = billingAttempts.find(
          (attempt) => attempt.BillingAttemptStatus === "SUCCESS"
        );
        return successfulAttempt
          ? new Date(successfulAttempt.CompletedAt)
          : window.Awtomic?.subscriptionOriginOrder?.createdAt
          ? new Date(window.Awtomic.subscriptionOriginOrder.createdAt)
          : new Date();
      })();

      const deliveryDayOfWeek = deliveryDateObj.getDay();
      const todayDayOfWeek = lastBillingDate.getDay();
      const daysUntilUpcomingDelivery =
        (deliveryDayOfWeek - todayDayOfWeek + 7) % 7;
      const upcomingDeliveryDate = new Date(
        lastBillingDate.getTime() +
          daysUntilUpcomingDelivery * 24 * 60 * 60 * 1000
      );
      console.log({
        lastBillingDate,
        deliveryDayOfWeek,
        todayDayOfWeek,
        daysUntilUpcomingDelivery,
        upcomingDeliveryDate,
      });
      const formattedUpcomingDeliveryDate =
        formatter.format(upcomingDeliveryDate);
      const nextBillingDate = new Date(subDetails.NextBillingDate);
      const billingDayOfWeek = nextBillingDate.getDay();
      const daysUntilNextDelivery =
        (deliveryDayOfWeek - billingDayOfWeek + 7) % 7;
      const nextDeliveryDate = new Date(
        nextBillingDate.getTime() + daysUntilNextDelivery * 24 * 60 * 60 * 1000
      );

      const formatter2 = new Intl.DateTimeFormat("en-NZ", options);
      const formattedNextDeliveryDate = formatter2.format(nextDeliveryDate);

      const innerObserver = new MutationObserver((mutations) => {
        const title = document.querySelector(".bundle-details-table-title");
        if (title && !document.querySelector(".delivery-date-container")) {
          innerObserver.disconnect();

          const lastOrderObserver = new MutationObserver((mutations) => {
            const lastOrderContainer = document.querySelector(
              "section.awt-last-order-container"
            );
            if (lastOrderContainer) {
              const deliveryDateContainer = document.createElement("div");
              deliveryDateContainer.classList.add("delivery-date-container");
              deliveryDateContainer.style.marginBottom = "5px";
              deliveryDateContainer.style.fontWeight = "600";
              const today = new Date();
              const isPast = upcomingDeliveryDate < today;
              const displayLastOrder = true; // Change this to true to toggle the feature live
              if (isPast && displayLastOrder) {
                deliveryDateContainer.innerHTML = `Your last confirmed order: ${formattedUpcomingDeliveryDate}`;
              } else {
                deliveryDateContainer.innerHTML = `Your next confirmed order: ${formattedUpcomingDeliveryDate}`;
              }
              lastOrderContainer.prepend(deliveryDateContainer);
              lastOrderObserver.disconnect();
            }
          });

          lastOrderObserver.observe(document.body, {
            childList: true,
            subtree: true,
          });

          setTimeout(() => {
            lastOrderObserver.disconnect();
          }, 5000);

          const notShipped = document.querySelector(".awt-last-order-badge");
          if (notShipped) notShipped.innerHTML = "Out for Delivery";

          const yourNextOrder = document.querySelector(
            ".bundle-details-table-title"
          );
          const yourBillingDate = document.querySelector(
            ".bundle-card--next-order-date .bundle-card__body div span:first-child"
          );

          // For the next order date
          if (yourNextOrder) {
            console.log("Your Next Delivery is:", nextDeliveryDate);
            console.log(
              "Formatted Next Delivery Date is:",
              formattedNextDeliveryDate
            );

            let nextOrderDate = yourNextOrder?.innerText?.split("•")[1]?.trim();
            if (nextOrderDate) {
              setTimeout(() => {
                yourNextOrder.innerHTML = `Edit your next order below before: ${formattedBillingDate}`;
                yourNextOrder.style.textTransform = "none";
                yourNextOrder.style.letterSpacing = "normal";
              }, 650);
            } else {
              console.error(
                "Invalid date format or unable to parse next order date:",
                nextOrderDate
              );
              //yourNextOrder.innerHTML = "Edit your next order below before: Invalid date";
            }
          } else {
            console.warn(
              "Next order date text is missing or improperly formatted in:",
              yourNextOrder
            );
          }

          // For the billing date
          if (yourBillingDate) {
            const deliveryDateLine = document.createElement("div");
            deliveryDateLine.style = "margin-bottom: 15px;";
            deliveryDateLine.innerHTML = `For delivery on: ${formattedNextDeliveryDate}`;
            yourNextOrder &&
              yourNextOrder.insertAdjacentElement("afterend", deliveryDateLine);
            yourBillingDate.innerHTML = `${formattedBillingDate}`;
          } else {
            console.error(
              "Invalid date format or unable to parse billing date:"
            );
            yourBillingDate.innerHTML = "Invalid date";
          }

          const subscriptionsTitle = document.querySelector(
            "nav.bundle-breadcrumb-container > a.bundle-breadcrumb-item--link"
          );
          if (subscriptionsTitle) {
            const backArrow = document.createElement("span");
            backArrow.innerHTML = "&#8592;";
            backArrow.style.marginRight = "5px";
            backArrow.style.cursor = "pointer";
            backArrow.addEventListener("click", () => {
              window.location.href = "/subscription-list";
            });

            subscriptionsTitle.prepend(backArrow);
          }
        }
      });

      innerObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      setTimeout(() => {
        //innerObserver.disconnect();
      }, 5000);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    observer.disconnect();
  }, 5000);
}
